import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
const CreateParcelModel = ({ modal, toggle, ParcelListApi, isEdit, parcelData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [qty, setQty] = useState(1)
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [paymentStatus, setPaymentStatus] = useState(isEdit ? parcelData.PayOrDue : true); // 'pay' selected by default
    const [levanuDevanuStatus, setLevanuDevanuStatus] = useState(isEdit ? parcelData.LevanuOrDevanu : true); // 'pay' selected by default

    useEffect(() => {
        if (parcelData) {
            setPaymentStatus(parcelData.PayOrDue);
            setLevanuDevanuStatus(parcelData.LevanuOrDevanu);
        }
    }, [parcelData])

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    // parcel Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: isEdit ? parcelData.Name : '',
            CourierPartner: isEdit ? parcelData.CourierPartner : '',
            Amount: isEdit ? parcelData.Amount : 0,
            Remark: isEdit ? parcelData.Remark : '',
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("The name is required"),
            CourierPartner: Yup.string().required("The Courier Partner is required"),
            Remark: Yup.string().required("The remark is required"),
            Amount: Yup.string().required("The amount is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {
                postApi("Parcel/create-update", {
                    Id: isEdit ? parcelData.Id : 0,
                    Name: values.Name,
                    CourierPartner: values.CourierPartner,
                    Amount: parseFloat(values.Amount),
                    Qty: parseInt(qty),
                    PayOrDue: paymentStatus,
                    LevanuOrDevanu: levanuDevanuStatus,
                    Remark: values.Remark,
                }).then(({ data, status }) => {
                    setformSumitLoading(false)
                    if (status == 400) {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.success("Sucessfully created", {
                            style: {
                                fontSize: "15px",
                            },
                        })
                        toggle()
                        if (ParcelListApi != '') {
                            ParcelListApi()
                        }
                        validation.handleReset()
                    }
                })
            }
        },
    })

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "400px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    Create Parcel
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name || ""}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>

                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Courier Partner
                                    </Label>
                                    <Input
                                        name="CourierPartner"
                                        placeholder="CourierPartner"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.CourierPartner || ""}
                                        invalid={
                                            validation.touched.CourierPartner && validation.errors.CourierPartner
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.CourierPartner && validation.errors.CourierPartner ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.CourierPartner}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03">
                                        Amount
                                    </Label>
                                    <Input
                                        name="Amount"
                                        placeholder="0"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        onKeyPress={handleKeyPress}
                                        value={validation.values.Amount}
                                        invalid={
                                            validation.touched.Amount && validation.errors.Amount
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Amount && validation.errors.Amount ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Amount}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4" className="">
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Qty
                                    </Label>
                                    <Input
                                        type="select"
                                        bsSize="sm"
                                        className="form-control-sm"
                                        name="qty"
                                        onChange={e => setQty(e.target.value)}
                                        onBlur={validation.handleBlur}
                                        value={qty}
                                    >
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                        <option value={6}>6</option>
                                        <option value={7}>7</option>
                                        <option value={8}>8</option>
                                        <option value={9}>9</option>
                                        <option value={10}>10</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <div style={{ marginTop: "30px" }}>
                                    <div className=" d-flex gap-2">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={true}
                                                id="Pay"
                                                className="form-check-input"
                                                checked={paymentStatus === true}
                                                onClick={() => { setPaymentStatus(true) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13" htmlFor="Pay" style={{ marginRight: "12px" }}>
                                            Pay
                                        </Label>
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={false}
                                                id="Due"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={paymentStatus === false}
                                                onClick={() => { setPaymentStatus(false) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13" htmlFor="Due">
                                            Due
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <div style={{}}>
                                    <div className=" d-flex gap-2">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={true}
                                                id="Levanu"
                                                className="form-check-input"
                                                checked={levanuDevanuStatus === true}
                                                onClick={() => { setLevanuDevanuStatus(true) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13" htmlFor="Levanu" style={{ marginRight: "12px" }}>
                                            Levanu
                                        </Label>
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value={false}
                                                id="Devanu"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={levanuDevanuStatus === false}
                                                onClick={() => { setLevanuDevanuStatus(false) }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13" htmlFor="Devanu">
                                            Devanu
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Remark
                                    </Label>
                                    <Input
                                        name="Remark"
                                        placeholder="Remark"
                                        type="textarea"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Remark || ""}
                                        invalid={
                                            validation.touched.Remark && validation.errors.Remark
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Remark && validation.errors.Remark ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Remark}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>

                            </Col>
                        </Row>
                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="reset"
                                color="secondary"
                            >
                                Reset
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default CreateParcelModel